import React, { Component } from 'react';
import { Card, Avatar, message, Input, List, Breadcrumb } from 'antd';
import { Redirect } from 'react-router-dom';
import PublicMenu from '../../components/TopMenu';
import axios from 'axios';
import Configuration from '../../Configuration';
const { Meta } = Card;
const Search = Input.Search;

class Job extends Component {
  constructor() {
    super();
    this.headers = {Authorization: localStorage.getItem('visitapp:token')};
    this.state = {redirect: false, job: {name: '', status: true, profiles: []}, filteredProfiles: []};
    this.validateToken = this.validateToken.bind(this);
    this.handleStatus = this.handleStatus.bind(this);
    this.getJob = this.getJob.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
  }

  componentDidMount() {
    this.validateToken();
    this.getJob();
  }

  validateToken() {
    if(!localStorage.getItem('visitapp:token'))
      this.setState({redirect: true});
    
    if(!Configuration.isInRol(localStorage.getItem('visitapp:rol'), "admin or manager"))
      this.setState({redirect: true});
  }

  getJob() {
    const id = this.props.match.params.id;

    axios.get(`${Configuration.apiServer}/api/v1/jobs/${id}`, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      this.setState({job: resp.data, filteredProfiles: resp.data.profiles});
    });
  }

  handleStatus(id) {
    axios.put(`${Configuration.apiServer}/api/v1/jobs/${id}/status`, {}, {headers: this.headers}).then(resp => {
      if(resp.status !== 200)
        return message.warning('Hubo un error al procesar los datos')
      
      if(resp.data.status === 'error')
        return message.warning('Petición inválida')

      message.success('Registro actualizado')
      this.getJob();
    });
  }

  handleSearch(event) {
    const profiles = this.state.job.profiles.filter(profile => {
      return profile.names.toLowerCase().indexOf(event.target.value.toLowerCase()) > -1
    });

    this.setState({filteredProfiles: profiles});
  }

  getName(record) {
    if(record) {
      return record.name;
    } else {
      return 'Sin nombre';
    }
  }
  
  render() {
    // Verify authentication
    if(this.state.redirect) {
      return (
        <Redirect to="/" />
      );
    }

    // Render component
    return (
      <div>
        <PublicMenu />
        
        <div className="container" style={{ marginTop: '30px' }}>
          <div className="d-flex flex-row flex-start">
            <Breadcrumb>
              <Breadcrumb.Item> <a href="/admin/jobs">Puestos</a> </Breadcrumb.Item>
              <Breadcrumb.Item>{this.state.job.name}</Breadcrumb.Item>
            </Breadcrumb>
          </div>

          <br/>

          <div className="d-flex flex-row flex-wrap justify-content-between">
            <div style={{ width: '30%', padding: '0px 10px' }}>
              <Search placeholder="Buscar..." onChange={this.handleSearch} style={{ width: '100%' }} />

              <br/><br/>

              <Card
                style={{ width: '100%', margin: '0px' }}
              >
                <Meta
                  avatar={<Avatar icon="solution" />}
                  title={this.state.job.name}
                  description={<span className={`cursor text-${Configuration.getStatus(this.state.job.status).color}`} onClick={() => { this.handleStatus(this.state.job.id) }}>{Configuration.getStatus(this.state.job.status).text}</span>}
                />
              </Card>
            </div>

            <div style={{ width: '70%', padding: '0px 10px' }}>
              <List
                itemLayout="horizontal"
                dataSource={this.state.filteredProfiles}
                renderItem={user => (
                  <List.Item>
                    <List.Item.Meta
                      avatar={<Avatar src="https://zos.alipayobjects.com/rmsportal/ODTLcjxAfvqbxHnVXCYX.png" />}
                      title={<a href="https://ant.design">{user.names}</a>}
                      description={`Sucursal ${this.getName(user.branch)} | Departamento ${this.getName(user.department)}`}
                    />
                  </List.Item>
                )}
              />
            </div>
          </div>
        </div>

      </div>
    );
  }
}

export default Job;



// WEBPACK FOOTER //
// ./src/pages/admin/Job.js